import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  FaChurch, FaCalendarAlt, 
  FaBell, FaSignOutAlt,
  FaHome, FaClock, FaMapMarkerAlt, FaEnvelope,
  FaQuoteRight, FaChartLine, FaCampground, FaUsers, FaQrcode, FaClipboardCheck
} from 'react-icons/fa';
import {
  PageContainer,
  Sidebar,
  SidebarHeader,
  Logo,
  NavSection,
  NavLabel,
  NavItem,
  LogoutButton,
  MainContent,
  TopBar,
  PageTitle,
  TopBarActions,
  IconButton,
  NotificationDot,
  UserAvatar,
  ContentArea
} from '../../styles/AdminStyles';

// Navigation configuration
const navItems = [
  { id: 'overview', path: '/admin/dashboard', label: 'Overview', icon: FaChartLine },
  { id: 'homepage', path: '/admin/dashboard', label: 'Homepage', icon: FaHome, state: { tab: 'homepage' } },
  { id: 'branches', path: '/admin/dashboard', label: 'Branches', icon: FaMapMarkerAlt, state: { tab: 'branches' } },
  { id: 'services', path: '/admin/dashboard', label: 'Services', icon: FaClock, state: { tab: 'services' } },
  { id: 'testimonials', path: '/admin/dashboard', label: 'Testimonials', icon: FaQuoteRight, state: { tab: 'testimonials' } },
];

const routeItems = [
  { path: '/admin/events', label: 'Events', icon: FaCalendarAlt },
  { path: '/admin/messages', label: 'Messages', icon: FaEnvelope },
  { path: '/admin/camp-dashboard', label: 'Camp Dashboard', icon: FaCampground },
  { path: '/admin/camp-registration', label: 'Camp Registrations', icon: FaUsers },
  { path: '/admin/camp-qr-codes', label: 'Generate QR Codes', icon: FaQrcode },
  { path: '/admin/camp-checkins', label: 'Camp Check-Ins', icon: FaClipboardCheck },
];

const AdminLayout = ({ children, title = "Admin Panel", subtitle = "Manage your website" }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user] = useState(JSON.parse(localStorage.getItem('user')) || {});
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin');
  };

  return (
    <PageContainer>
      <Sidebar>
        <SidebarHeader>
          <Logo>
            <FaChurch />
            <span>ELC Admin</span>
          </Logo>
        </SidebarHeader>

        <NavSection>
          <NavLabel>Dashboard</NavLabel>
          {navItems.map(item => (
            <NavItem
              key={item.id}
              as={Link}
              to={item.path}
              state={item.state}
              $active={location.pathname === item.path && !item.state}
            >
              <item.icon /> {item.label}
            </NavItem>
          ))}

          <NavLabel>Management</NavLabel>
          {routeItems.map(item => (
            <NavItem
              key={item.path}
              as={Link}
              to={item.path}
              $active={location.pathname === item.path}
            >
              <item.icon /> {item.label}
            </NavItem>
          ))}
        </NavSection>

        <LogoutButton onClick={handleLogout}>
          <FaSignOutAlt /> Logout
        </LogoutButton>
      </Sidebar>

      <MainContent>
        <TopBar>
          <PageTitle>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </PageTitle>
          <TopBarActions>
            <IconButton>
              <FaBell />
              <NotificationDot />
            </IconButton>
            <UserAvatar>
              {user.firstName?.[0] || 'A'}
            </UserAvatar>
          </TopBarActions>
        </TopBar>

        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
    </PageContainer>
  );
};

export default AdminLayout;
